import React from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import { BookingConfig, BookingConfigLimits } from '../../types';
import { NumberField } from '../Inputs/NumberField';

interface BookingLimitsFormProps {
  formData: Partial<BookingConfig>;
  onChange: (field: keyof BookingConfig, value: any) => void;
  errors: Record<string, string | null>;
}

export const BookingLimitsForm: React.FC<BookingLimitsFormProps> = ({ formData, onChange, errors }) => {
  return (
    <Card sx={{ mb: 4, borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
      <CardContent sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
          Booking Limits
        </Typography>
        <Typography color="textSecondary" sx={{ mb: 3 }}>
          Set maximum number of appointments a single lead can book within a specific timeframe.
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4} data-booking-error-key="booking_limits_daily">
            <NumberField
              fullWidth
              label="Daily Limit"
              value={formData.booking_limits?.daily ?? ''}
              onChange={(val) => {
                onChange('booking_limits', { ...formData.booking_limits, daily: val === '' ? null : parseInt(val) } as any);
              }}
              error={!!errors.booking_limits_daily}
              helperText={errors.booking_limits_daily || "Max bookings per day"}
              min={1}
            />
          </Grid>
          <Grid item xs={12} md={4} data-booking-error-key="booking_limits_weekly">
            <NumberField
              fullWidth
              label="Weekly Limit"
              value={formData.booking_limits?.weekly ?? ''}
              onChange={(val) => {
                onChange('booking_limits', { ...formData.booking_limits, weekly: val === '' ? null : parseInt(val) } as Partial<BookingConfigLimits>);
              }}
              error={!!errors.booking_limits_weekly}
              helperText={errors.booking_limits_weekly || "Max bookings per week"}
              min={1}
            />
          </Grid>
          <Grid item xs={12} md={4} data-booking-error-key="booking_limits_monthly">
            <NumberField
              fullWidth
              label="Monthly Limit"
              value={formData.booking_limits?.monthly ?? ''}
              onChange={(val) => {
                onChange('booking_limits', { ...formData.booking_limits, monthly: val === '' ? null : parseInt(val) } as Partial<BookingConfigLimits>);
              }}
              error={!!errors.booking_limits_monthly}
              helperText={errors.booking_limits_monthly || "Max bookings per month"}
              min={1}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
